export const MetricType = {
	BASIC: 'BASIC',
	GRAPH: 'GRAPH',
	GRID_BUTTON: 'GRID_BUTTON',
	SEPARATOR: 'SEPARATOR',
	ACCUMULATOR: 'ACCUMULATOR',
};
